module.exports = __webpack_public_path__ + "static/media/price-indicator.3d6c97a4.svg";